var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedroomBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.25L14.3813 7.75L15.515 10.4425C15.67 10.8107 15.7499 11.2061 15.75 11.6056V13.25C15.75 13.4489 15.671 13.6397 15.5303 13.7803C15.3897 13.921 15.1989 14 15 14H1C0.801088 14 0.610322 13.921 0.46967 13.7803C0.329018 13.6397 0.25 13.4489 0.25 13.25V11.6056C0.250026 11.2059 0.329924 10.8103 0.485 10.4419L2.05687 6.70875C2.11431 6.57247 2.21075 6.4562 2.33407 6.37458C2.4574 6.29295 2.60211 6.24961 2.75 6.25H8.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5C8.75 4.5 9 4 9 4C10.1429 3.66667 11.3571 3.66667 12.5 4C12.5 4 12.75 4.5 12.75 5C12.75 5.5 12.5 6 12.5 6",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5C3.25 4.5 3.5 4 3.5 4C4.64286 3.66667 5.85714 3.66667 7 4C7 4 7.25 4.5 7.25 5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15V15.25C1.25 15.3826 1.30268 15.5098 1.39645 15.6036C1.49021 15.6973 1.61739 15.75 1.75 15.75H2.75C2.88261 15.75 3.00979 15.6973 3.10355 15.6036C3.19732 15.5098 3.25 15.3826 3.25 15.25V15",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15V15.25C12.75 15.3826 12.8027 15.5098 12.8964 15.6036C12.9902 15.6973 13.1174 15.75 13.25 15.75H14.25C14.3826 15.75 14.5098 15.6973 14.6036 15.6036C14.6973 15.5098 14.75 15.3826 14.75 15.25V15",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7.75L9.96437 8.9075C10.0508 9.01113 10.1636 9.08952 10.2909 9.1344C10.4182 9.17927 10.5552 9.18898 10.6875 9.1625L12.75 8.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11H13.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5V3.5C0.75 1.47563 4.41 0.25 8 0.25C11.59 0.25 15.25 1.47563 15.25 3.5V5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroomBed);
export default __webpack_public_path__ + "static/media/bedroom-bed.efebdb6b.svg";
export { ForwardRef as ReactComponent };